var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '../../common';
import { BsDiscord, BsFillEnvelopeFill, BsTwitter, BsGithub, BsYoutube, BsMedium, BsTelegram, BsLinkedin, } from 'react-icons/bs';
import styles from './Footer.module.css';
var DISCORD_INVITE_URL = 'https://discord.com/invite/subquery';
var CONTRIBUTE_URL = 'https://academy.subquery.network/miscellaneous/contributing.html';
var GET_SUPPORT = 'Get Support On Discord';
var JOIN = 'Join the Future';
var CONTRIBUTE = 'Contribute';
var COPYRIGHT = "Subquery \u00A9 ".concat(new Date().getFullYear());
var links = [
    { link: 'mailto:hello@subquery.network', icon: _jsx(BsFillEnvelopeFill, {}, void 0) },
    { link: 'https://twitter.com/subquerynetwork', icon: _jsx(BsTwitter, {}, void 0) },
    { link: 'https://medium.com/@subquery', icon: _jsx(BsMedium, {}, void 0) },
    { link: 'https://github.com/OnFinality-io/subql', icon: _jsx(BsGithub, {}, void 0) },
    { link: 'https://youtube.com/c/SubQueryNetwork', icon: _jsx(BsYoutube, {}, void 0) },
    { link: 'https://t.me/subquerynetwork', icon: _jsx(BsTelegram, {}, void 0) },
    { link: 'https://www.linkedin.com/company/subquery', icon: _jsx(BsLinkedin, {}, void 0) },
    { link: 'https://discord.com/invite/subquery', icon: _jsx(BsDiscord, {}, void 0) },
];
export var IconLinks = function (_a) {
    var _b = _a.allLinks, allLinks = _b === void 0 ? true : _b;
    return (_jsx("div", __assign({ className: styles.icons }, { children: allLinks
            ? links.map(function (_a) {
                var link = _a.link, icon = _a.icon;
                return (_jsx("a", __assign({ href: link, target: "_blank", rel: "noreferrer" }, { children: _jsx("div", __assign({ className: styles.icon }, { children: icon }), void 0) }), link));
            })
            : links.slice(0, -1).map(function (_a) {
                var link = _a.link, icon = _a.icon;
                return (_jsx("a", __assign({ href: link, target: "_blank", rel: "noreferrer" }, { children: _jsx("div", __assign({ className: styles.icon }, { children: icon }), void 0) }), link));
            }) }), void 0));
};
var Default = function () {
    return (_jsx("div", __assign({ className: styles.footerWrapper }, { children: _jsxs("div", __assign({ className: styles.footer }, { children: [_jsxs("div", __assign({ className: styles.primaryRow }, { children: [_jsxs("div", __assign({ className: styles.contact }, { children: [_jsx("h5", { children: JOIN }, void 0), _jsx(IconLinks, { allLinks: false }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.discord }, { children: _jsx(Button, { type: "secondary", colorScheme: "standard", href: DISCORD_INVITE_URL, leftItem: _jsx(BsDiscord, {}, void 0), label: GET_SUPPORT, size: "medium" }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: styles.secondaryRow }, { children: _jsx(Typography, __assign({ variant: "medium" }, { children: COPYRIGHT }), void 0) }), void 0)] }), void 0) }), void 0));
};
var Simple = function () {
    return (_jsxs("div", __assign({ className: styles.simpleContainer }, { children: [_jsx("div", __assign({ className: styles.iconsContainer }, { children: _jsx(IconLinks, {}, void 0) }), void 0), _jsx("div", __assign({ className: styles.simpleCopyRight }, { children: _jsxs(Typography, __assign({ variant: "small", type: "neutral" }, { children: [COPYRIGHT, _jsx("a", __assign({ href: CONTRIBUTE_URL, className: styles.bottomLink }, { children: CONTRIBUTE }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export var Footer = function (_a) {
    var simple = _a.simple;
    if (simple)
        return _jsx(Simple, {}, void 0);
    return _jsx(Default, {}, void 0);
};
